// extracted by mini-css-extract-plugin
export default {"landingWrapper":"res_landingWrapper__96N+f","container":"res_container__Jy2ZZ","result":"res_result__stw1U","management":"res_management__lxE8O"};